import { ServiceProvider, ServiceProviderMap } from './service-provider.enum';

export enum ServiceAuthType {
  Dropbox = 'dropbox',
  Google = 'google',
  MicrosoftPersonalFull = 'microsoft-personal-full',
  MicrosoftTeamFull = 'microsoft-full',
  MicrosoftTeamSites = 'microsoft-sites',
  Zoho = 'zoho',
}

export type ServiceAuthTypeMap<T> = Record<ServiceAuthType, T>;

export function assertIsServiceAuthType(value: any): asserts value is ServiceAuthType {
  if (!Object.values(ServiceAuthType).includes(value)) {
    throw new Error(`Invalid service auth type: ${value}`);
  }
}

export function getServiceAuthTypeProvider(value: ServiceAuthType): ServiceProvider {
  const providerMap: ServiceAuthTypeMap<ServiceProvider> = {
    [ServiceAuthType.Dropbox]: ServiceProvider.Dropbox,
    [ServiceAuthType.Google]: ServiceProvider.Google,
    [ServiceAuthType.MicrosoftPersonalFull]: ServiceProvider.Microsoft,
    [ServiceAuthType.MicrosoftTeamFull]: ServiceProvider.Microsoft,
    [ServiceAuthType.MicrosoftTeamSites]: ServiceProvider.Microsoft,
    [ServiceAuthType.Zoho]: ServiceProvider.Zoho,
  };

  return providerMap[value];
}

export function getServiceProviderDefaultAuthType(value: ServiceProvider): ServiceAuthType {
  const authTypeMap: ServiceProviderMap<ServiceAuthType> = {
    [ServiceProvider.Dropbox]: ServiceAuthType.Dropbox,
    [ServiceProvider.Google]: ServiceAuthType.Google,
    [ServiceProvider.Microsoft]: ServiceAuthType.MicrosoftTeamFull,
    [ServiceProvider.Zoho]: ServiceAuthType.Zoho,
  };

  return authTypeMap[value];
}
